import React from "react";

import LoaderImage from "./loader.png";

import "./loader.css";

interface Props {
  style?: React.CSSProperties;
  className?: string;
  visible?: boolean | string;
  errorMessage?: string;
}

const Loader = ({ style = {}, className = "", visible = true, errorMessage }: Props) => {
  if (!visible || visible === "false") {
    return null;
  }

  if (errorMessage) {
    return <div>{errorMessage}</div>;
  }

  return (
    <div className="loading">
      <div aria-busy="true" className={className} style={style}>
        <img src={LoaderImage} className="App-logo" />
      </div>
    </div>
  );
};

export default Loader;
